import { Search as SearchIcon } from "@mui/icons-material";
import {
  Box,
  Button,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { differenceInDays } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";

const TIPO_PERIODO_OPTIONS = [
  { value: "data_reserva", label: "Data de Criação" },
  { value: "checkin", label: "Check-in" },
  { value: "checkout", label: "Check-out" },
];

const MotorHeader = ({
  loading,
  setDataInicio,
  setDataFim,
  dataInicio,
  dataFim,
  tipoPeriodo,
  setTipoPeriodo,
  handleFetchDados,
  openFilterModal,
  quantityFiltered,
  resetFilters,
  activeFilterChips = [],
  onRemoveFilter,
  totalResultados = 0,
  totalCarregados = 0,
}) => {
  const tipoPeriodoLabel =
    TIPO_PERIODO_OPTIONS.find((option) => option.value === tipoPeriodo)?.label ||
    "Data de Criação";

  const handleChangeDataInicio = (date) => {
    setDataInicio(date);
  };

  const handleChangeDataFim = (date) => {
    const diff = differenceInDays(date, dataInicio);

    if (diff < 0) {
      return alert("Selecione um período maior que a data fim");
    }

    setDataFim(date);
  };

  return (
    <>
      <Grid container columns={12}>
        <Grid item size={12}>
          <FormControl sx={{ m: 1, minWidth: 180 }}>
            <InputLabel id="tipo-periodo-label">Buscar por</InputLabel>
            <Select
              labelId="tipo-periodo-label"
              label="Buscar por"
              value={tipoPeriodo}
              onChange={(e) => setTipoPeriodo(e.target.value)}
              sx={{ fontFamily: "Montserrat", minHeight: 56 }}
            >
              {TIPO_PERIODO_OPTIONS.map((option) => (
                <MenuItem
                  key={option.value}
                  value={option.value}
                  sx={{ fontFamily: "Montserrat" }}
                >
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl sx={{ m: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
              <DatePicker
                label={`${tipoPeriodoLabel} - Início`}
                inputFormat="dd/MM/yyyy"
                value={dataInicio || null}
                onChange={handleChangeDataInicio}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </FormControl>

          <FormControl sx={{ m: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
              <DatePicker
                label={`${tipoPeriodoLabel} - Fim`}
                inputFormat="dd/MM/yyyy"
                value={dataFim || null}
                onChange={handleChangeDataFim}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </FormControl>

          <FormControl sx={{ m: 1, minWidth: 60 }}>
            <Button
              sx={{
                p: 2,
                color: "#fff",
                minHeight: 56,
              }}
              color="tertiary"
              variant="contained"
              onClick={() => handleFetchDados(dataInicio, dataFim, tipoPeriodo)}
              loading={loading}
              loadingPosition="center"
            >
              {!loading && <SearchIcon />}
            </Button>
          </FormControl>

          <FormControl sx={{ m: 1, minWidth: 60 }}>
            <Button
              sx={{ maxHeight: 56, textTransform: "capitalize", p: 2 }}
              variant="contained"
              color="secondary"
              onClick={openFilterModal}
            >
              Filtros
              <Box
                sx={{
                  backgroundColor: "#FBAF17",
                  color: "#fff",
                  fontWeight: 700,
                  borderRadius: 100,
                  height: 24,
                  width: 24,
                  textAlign: "center",
                  ml: 1,
                }}
              >
                {quantityFiltered}
              </Box>
            </Button>
          </FormControl>

          {quantityFiltered > 0 && (
            <FormControl sx={{ m: 1, minWidth: 60 }}>
              <Button
                sx={{ maxHeight: 56, textTransform: "capitalize", ml: 1, p: 2 }}
                variant="contained"
                color="secondary"
                onClick={resetFilters}
              >
                Limpar Filtros
              </Button>
            </FormControl>
          )}
        </Grid>
      </Grid>

      <Box sx={{ mx: 1, mt: 1, display: "flex", flexWrap: "wrap", gap: 1, alignItems: "center" }}>
        <Typography sx={{ fontFamily: "Montserrat", fontSize: 14, color: "#555" }}>
          {quantityFiltered > 0
            ? `${totalResultados} de ${totalCarregados} reservas`
            : `${totalCarregados} reservas no período`}
        </Typography>

        {activeFilterChips.map((chip) => (
          <Chip
            key={chip.key}
            label={`${chip.label}: ${chip.value}`}
            onDelete={() => onRemoveFilter(chip.key)}
            sx={{ fontFamily: "Montserrat" }}
          />
        ))}
      </Box>
    </>
  );
};

export default MotorHeader;
